import type { ListBuilderList } from '../../../types';
import { createStandardClientColumns } from '../columns';
import {
	createClientKanbanConfig,
	DEFAULT_LIST_REQUIRED_FIELDS,
} from '../shared';

/**
 * Unassigned Clients list configuration
 * Shows clients with no salesperson assigned, allowing salespeople to discover unclaimed clients.
 * The salespeople filter is locked to "Unassigned" since that is the entire purpose of this list.
 */
export const unassignedClientsList: ListBuilderList = {
	id: 'unassigned',
	visibleIf: 'clients:view:unassigned',
	cacheTTL: 600000,
	name: 'Unassigned',
	type: 'default',
	active: true,
	bulkActionTemplate: 'clients',
	sortOrder: 12,
	filterRules: {
		salespeople: {
			defaultValue: [
				{
					id: 'null',
					label: 'Unassigned',
				},
			],
			// Lock the salespeople filter for users without clients:list:any so they
			// cannot change it away from "Unassigned". Users with list:any (incl.
			// salespeople in tenants where it's granted) can freely modify it.
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'clients:list:any', negated: true }],
			},
		},
	},
	columns: createStandardClientColumns(),
	description: 'Clients with no assigned salesperson',
	defaultSortId: 'column-client-name-asc',
	requiredFields: DEFAULT_LIST_REQUIRED_FIELDS,
	kanbanConfig: createClientKanbanConfig(),
};
